import { render, staticRenderFns } from "./ClipboardGeneral.vue?vue&type=template&id=617a0f8c&scoped=true&"
import script from "./ClipboardGeneral.vue?vue&type=script&lang=js&"
export * from "./ClipboardGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ClipboardGeneral.vue?vue&type=style&index=0&id=617a0f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a0f8c",
  null
  
)

export default component.exports